// extracted by mini-css-extract-plugin
module.exports = {"fileStatusContainer":"consumptionDcbFileHistory_fileStatusContainer__29p7E","loadMoreBtnContainer":"consumptionDcbFileHistory_loadMoreBtnContainer__1p1OR"};